const getMonth = (index) => KROWN.settings.locales[['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'][index]];
// get midnight date for correct date calculation
const getMidnightDate = (date) => {
  const pattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|[+-]\d{2}:\d{2})$/; // ISO format for dates regex
  const userTimezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;

  if (date) {
    if (pattern.test(date)) {
      // create timezone adjusted date from param and strip time info
      return new Date(new Date(new Date(date).getTime() + userTimezoneOffset).setHours(0, 0, 0, 0));
    } else {
      // date is not in ISO format so no time info present, hence timezone adjustment not needed
      return new Date(new Date(new Date(date).getTime()).setHours(0, 0, 0, 0));
    }
  } else {
    // create new timezone adjusted date and strip time info
    return new Date(new Date(new Date().getTime() + userTimezoneOffset).setHours(0, 0, 0, 0));
  }
};

// Format date object to ISO string format (YYYY-M-D T00:00:00.000Z) to prevent timezone shift
const formatDateToISO = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).toString().padStart(2, '0');
  const day = String(date.getDate()).toString().padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00.000Z`;
};

const _formatMoney= (cents, format) => {

  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  // const formatString = format| moneyFormat;
  const formatString = format;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (Math.round(number) / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);

}

/*
* Get the `checkout_url` from the URL query parameter, if it exists.
* (It only ever exists on the /account/login page)
*/
function getCheckoutUrl() {  
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  return getParameterByName('checkout_url');
}

/*
* removing hsf child attributes during cart clear
*/
function updateAndRemoveHsfAttributes() {
  const body = {
      attributes: {
        hsfChildDetails: null
      }
    }

  return fetch(KROWN.settings.routes.cart_update_url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/javascript",
    },
    body: JSON.stringify(body),
  })
}
